export default __webpack_public_path__ + "static/media/docs-burnout-symptoms-quantity-man.e0071aae.png";